import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectUserLoggedIn } from 'src/store/slices/user-slice';
import { getRebookerActive } from 'src/api/rebookersService';
import { getRoomCode } from 'src/utils/local-storage-versioning';

export const useGetRebookerActive = () => {
    const [searchParams] = useSearchParams();
    const roomCode = getRoomCode(searchParams) ?? '';
    const userLoggedIn = useSelector(selectUserLoggedIn);

    const query = useQuery<boolean, AxiosError>({
        enabled: userLoggedIn && !!roomCode,
        queryKey: ['isRebookerActive'],
        queryFn: () => getRebookerActive(roomCode),
    });

    return {
        ...query,
    };
};
